import React, { useEffect, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useStoreon } from 'storeon/react';

import BlockCustomerInfo from '../../BlockCustomerInfo';
import BlockContactMethod from '../../BlockContactMethod';
import BlockDescribeProblemMiwindows from '../../BlockDescribeProblemMiwindows';

import Btn from "../../Btn";
import Info from "../../Info";
import axios from "axios";
import Loader from '../../Loader';

const ServiceRequestMiwindowsForm = ( { id } ) => {
    const [serverResponse , setServerResponse] = useState('');
    const [submitForm , setSubmitForm] = useState(false);

    const methods = useForm( {
        mode: 'all',
        reValidateMode: 'onChange',
        // Default values for field array.
        defaultValues: {
            your_project: [{}],
        },
    } );
    const { errors, trigger, handleSubmit, formState } = methods;

    const onSubmit = ( data ) => {
        const endpointUrl = `${window.location.origin}/sr/api`;
        setSubmitForm(true);

        axios( {
            method: 'post',
            url: endpointUrl,
            data: data,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        } )
            .then((response) => {
                if (response.status === 200) {
                    window.location.href = `${window.location.origin}${window.location.pathname.replace( /\/+$/, '' )}/submission`;
                }
            })
            .catch( ( error ) => {
                setServerResponse(error.response.data);
                setSubmitForm(false);
                console.log( error );
            } );
    }
    const { dispatch, groups } = useStoreon( 'groups' );
    /**
     * Trigger form validation on component init.
     * This action will pre-populate errors object.
     */
    useEffect( () => {
        trigger();
    }, [trigger] );
    /**
     * Check form errors and determine if fieldset should be disabled.
     */

    useEffect( () => {
        for ( let i = 1; i < groups.length; i += 1 ) {
            const { fields: groupFields } = groups[i - 1];
            const isValid = !Object.keys( errors ).some( ( item ) => groupFields.includes( item ) );
            if ( groups[i].disabled === isValid ) {
                dispatch( 'CHANGE_FIELDSET_STATE', { id: i, disabled: !isValid } );
            }
        }
    } );

    return (
        <div className={`service-request-form container`}>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit( onSubmit )}>
                    <h1 className={'title-big'}>Need to schedule service for Anlin windows or doors? </h1>
                    <Info styleText={'text-grey mb-none'}>
                        Fill out the form below and our service team will contact you soon.
                    </Info>
                    <Info styleText={'text-grey b mb-none'}>
                        NOTE: You will need your Sales Order Number (preferred) or product information
                        in order for us to review your request.
                    </Info>
                    <Info styleText={'text-grey mb-none'}>
                        Not sure how to find it? <a href="https://www.youtube.com/watch?v=FWO_d9Sqx9E" target="_blank"
                                                    rel="noopener noreferrer">Click here.</a>
                    </Info>
                    <BlockDescribeProblemMiwindows index={0} idForm={id}/>
                    <BlockCustomerInfo index={1}/>
                    <BlockContactMethod index={2}/>
                    <Info>
                        After you click Submit, you will receive an email confirmation from MI Windows and Doors. A customer service
                        representative will contact you once they have reviewed the information provided.
                    </Info>
                    <Btn disabled={!formState.isValid || submitForm}><input type="submit" disabled={!formState.isValid || submitForm} value={'Request Service'}/></Btn>
                    {serverResponse &&  <div className="server-error">{ serverResponse }</div>}
                </form>
            </FormProvider>
            {submitForm && <Loader />}
        </div>
    );
};

export default ServiceRequestMiwindowsForm;
